exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".x-hellosign-embedded{z-index:1400}", ""]);
